import React from 'react';
import { StickyCTA } from './components/StickyCTA';
import { ArticlePage } from './pages/ArticlePage';
export function App() {
  return <div className="w-full min-h-screen pt-[60px] max-[500px]:pt-[90px] bg-white" data-id="element-0">
      <StickyCTA data-id="element-1" />
      <ArticlePage data-id="element-2" />
    </div>;
}